import { Icon, IconProps } from "../";

export const CopyContentIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.25 2C8.2835 2 7.5 2.7835 7.5 3.75V16.75C7.5 17.7165 8.2835 18.5 9.25 18.5H18.25C19.2165 18.5 20 17.7165 20 16.75V3.75C20 2.7835 19.2165 2 18.25 2H9.25ZM9 3.75C9 3.61193 9.11193 3.5 9.25 3.5H18.25C18.3881 3.5 18.5 3.61193 18.5 3.75V16.75C18.5 16.8881 18.3881 17 18.25 17H9.25C9.11193 17 9 16.8881 9 16.75V3.75ZM5.5 7C5.5 6.58579 5.16421 6.25 4.75 6.25C4.33579 6.25 4 6.58579 4 7V19.75C4 20.9926 5.00736 22 6.25 22H15C15.4142 22 15.75 21.6642 15.75 21.25C15.75 20.8358 15.4142 20.5 15 20.5H6.25C5.83579 20.5 5.5 20.1642 5.5 19.75L5.5 7Z"
      />
    </Icon>
  );
};
